export default __webpack_public_path__ + "297e1ce0c3c5c465d9007ab738bde685.png";